import React, { useEffect, useState } from 'react';
import { CheckCircleIcon, XIcon } from 'lucide-react';
interface SaleNotification {
  name: string;
  city: string;
  timeAgo: string;
}
const SALES_DATA: SaleNotification[] = [{
  name: 'Maria S.',
  city: 'São Paulo, SP',
  timeAgo: '2 minutos'
}, {
  name: 'Ana Paula R.',
  city: 'Rio de Janeiro, RJ',
  timeAgo: '5 minutos'
}, {
  name: 'Fernanda L.',
  city: 'Belo Horizonte, MG',
  timeAgo: '8 minutos'
}, {
  name: 'Juliana M.',
  city: 'Curitiba, PR',
  timeAgo: '12 minutos'
}, {
  name: 'Camila O.',
  city: 'Salvador, BA',
  timeAgo: '15 minutos'
}, {
  name: 'Patrícia G.',
  city: 'Brasília, DF',
  timeAgo: '18 minutos'
}, {
  name: 'Luciana T.',
  city: 'Fortaleza, CE',
  timeAgo: '22 minutos'
}, {
  name: 'Renata B.',
  city: 'Recife, PE',
  timeAgo: '25 minutos'
}, {
  name: 'Carla D.',
  city: 'Porto Alegre, RS',
  timeAgo: '30 minutos'
}, {
  name: 'Beatriz F.',
  city: 'Goiânia, GO',
  timeAgo: '35 minutos'
}, {
  name: 'Tatiane V.',
  city: 'Manaus, AM',
  timeAgo: '40 minutos'
}, {
  name: 'Débora C.',
  city: 'Campinas, SP',
  timeAgo: '45 minutos'
}];
export function SalesPopup() {
  const [current, setCurrent] = useState<SaleNotification | null>(null);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let index = 0;
    const initialDelay = setTimeout(() => {
      showNotification(index);
      index++;
      const interval = setInterval(() => {
        if (index >= SALES_DATA.length) index = 0;
        showNotification(index);
        index++;
      }, 12000);
      return () => clearInterval(interval);
    }, 6000);
    return () => clearTimeout(initialDelay);
  }, [dismissed]);
  const showNotification = (idx: number) => {
    setCurrent(SALES_DATA[idx]);
    setVisible(true);
    setTimeout(() => {
      setVisible(false);
    }, 5000);
  };
  if (dismissed || !current) return null;
  return <div className={`fixed bottom-16 right-4 z-40 max-w-xs w-full ${visible ? 'animate-slide-in-right' : 'animate-slide-out-right'}`} role="status" aria-live="polite" data-id="element-319">
      <div className="bg-white rounded-xl shadow-2xl border border-gray-100 p-4 flex items-start gap-3" data-id="element-320">
        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-green-100 flex items-center justify-center" data-id="element-321">
          <CheckCircleIcon className="w-5 h-5 text-green-600" aria-hidden="true" data-id="element-322" />
        </div>
        <div className="flex-1 min-w-0" data-id="element-323">
          <p className="text-sm font-semibold text-gray-900 truncate" data-id="element-324">
            {current.name}
          </p>
          <p className="text-xs text-gray-600" data-id="element-325">Comprou o Protocolo Airfryer</p>
          <p className="text-xs text-gray-400 mt-0.5" data-id="element-326">
            {current.city} · há {current.timeAgo}
          </p>
        </div>
        <button onClick={() => setDismissed(true)} className="flex-shrink-0 text-gray-300 hover:text-gray-500 transition-colors" aria-label="Fechar notificação" data-id="element-327">
          <XIcon className="w-4 h-4" data-id="element-328" />
        </button>
      </div>
    </div>;
}